module.exports = __webpack_public_path__ + "static/img/curriculum2.1045390.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/curriculum2.png
// module id = mhla
// module chunks = 0